import React from "react";
import Notes from "../../Kanban/LeadForm/Notes";

const InternalNotes = () => {
  return (
    <div className="mb-3">
      <label className="form-label">Internal Notes</label>
      <Notes
        name="description"
        style={{
          width: "1100px",
          margin: "15px",
          padding: "5px",
          border: "1px solid #CBCBCB",
          margin: "10px 15px 15px",
          padding: "10px",
          borderRadius: "15px",
          color: "#535559",
          height: "162px",
          backgroundColor: "#f5f5f5",
        }}
      />
    </div>
  );
};

export default InternalNotes;
